import React, { useEffect, useState } from "react";
import styled from "styled-components";

export default function Footer() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);

  function handleWindowSizeChange() {
    setIsMobile(window.innerWidth <= 900);
  }

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [window.location]);

  return (
    <FooterWrapper>
      <InstagramHandle
        style={{ cursor: "pointer" }}
        onClick={() => window.open(instagramPosts[0].link, "_blank")}
      >
        @RAINBOWTROUTREVERIE
      </InstagramHandle>
      <InstagramWrapper>
        {instagramPosts.map((post, idx) => (
          <a
            key={idx}
            href={post.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <InstaImage src={post.img} alt={`Instagram ${idx + 1}`} />
          </a>
        ))}
      </InstagramWrapper>

      <MiddleSection>
        {!isMobile && (
          <NavColumn>
            <a href="/">Home</a>
            <a href="about">About</a>
          </NavColumn>
        )}

        {isMobile && (
          <Row
            style={{
              justifyContent: "space-evenly",
              width: "100%",
              marginTop: 20,
              marginBottom: 20,
            }}
          >
            <NavColumn style={{ marginBottom: 40 }}>
              <a href="/">Home</a>
              <a href="/about">About</a>
            </NavColumn>
            <NavColumn style={{ marginBottom: 40 }}>
              <a href="/portfolio">Portfolio</a>
              <a href="/inquire">Inquire</a>
            </NavColumn>
          </Row>
        )}

        <LogoSection>
          <LogoTitle>RAINBOW TROUT REVERIE</LogoTitle>
          <div className="copyright">
            <a
              href="https://spencerwmathews.com"
              target="_blank"
              rel="noreferrer"
            >
              WEB DESIGN BY DEV.SPENCER
            </a>
          </div>
        </LogoSection>

        {!isMobile && (
          <NavColumn className="right">
            <a href="portfolio">Portfolio</a>
            <a href="#inquire">Inquire</a>
          </NavColumn>
        )}
      </MiddleSection>
    </FooterWrapper>
  );
}

const FooterWrapper = styled.footer`
  background-color: #fcfaf2;
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const InstagramWrapper = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 40px;
  flex-wrap: wrap;
  justify-content: center;
`;

const InstaImage = styled.img`
  width: 150px;
  height: 150px;
  object-fit: cover;
  border-radius: 4px;
  transition: transform 0.3s ease, opacity 0.3s ease;

  &:hover {
    transform: scale(1.05);
    opacity: 0.85;
  }
`;

const MiddleSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  width: 100%;
  text-align: center;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 30px;
  }
`;

const NavColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: -50px;

  a {
    color: #333;
    text-decoration: none;
    font-size: 18px;
    transition: color 0.3s ease;

    &:hover {
      color: #000;
    }
  }

  &.right {
    text-align: right;
  }
`;

const LogoSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .logo {
    font-size: 36px;
    font-family: serif;
    margin-bottom: 10px;
  }

  .copyright {
    font-size: 14px;
    color: #555;

    a {
      color: #555;
      text-decoration: underline;
      margin-left: 5px;
      transition: color 0.3s ease;

      &:hover {
        color: #000;
      }
    }
  }
`;

const LogoTitle = styled.h1`
  font-size: 2em;
  font-weight: 300;
  color: #333;
  cursor: pointer;
  border: 1px solid #333;
  border-radius: 10px;
  padding: 10px 5px 0px 5px;
  background-color: #fcfaf2;
  margin-top: -70px;
`;

const Row = styled.section`
  display: flex;
  flex-direction: row;
`;

const InstagramHandle = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #888;
  margin-bottom: 15px;
`;

const instagramPosts = [
  {
    img: "https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/cover1.webp",
    link: "https://www.instagram.com/rainbowtroutreverie/#",
  },
  {
    img: "https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Jeanne+Leo/JL12.webp",
    link: "https://www.instagram.com/rainbowtroutreverie/#",
  },
  {
    img: "https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Gower/18.webp",
    link: "https://www.instagram.com/rainbowtroutreverie/#",
  },
  {
    img: "https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Desteni+Devin/DD12.webp",
    link: "https://www.instagram.com/rainbowtroutreverie/#",
  },
  {
    img: "https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Gower/14.webp",
    link: "https://www.instagram.com/rainbowtroutreverie/#",
  },
];
